export default {
  title: 'Start your subscription',
  title_confirm: 'Confirm your plan',
  step: 'Step {{current}} of {{total}}',
  subtitle: '{{name}} · 1 location',
  trial_badge: '{{days}} days free',
  trial_headline: 'First {{days}} days free',
  then_price: 'Then {{price}} / month per location · incl. applicable tax',
  price_per_month: '{{price}} / month',
  price_terms: 'Per location, billed monthly · incl. applicable tax',
  tier_upsell:
    'Scale to {{threshold}}+ live locations and the rate for all your locations drops to {{price}} / month per location — automatically.',
  tier_active: 'Volume rate — {{threshold}}+ live locations',
  due_today: 'Due today',
  from_date: 'From {{date}}',
  no_charge_today: 'You won’t be charged today.',
  no_charge_until: 'You won’t be charged today. Cancel by {{date}} and you pay nothing.',
  active: '{{plan}} is active for this restaurant.',
  active_with_trial: '{{plan}} is active for this restaurant, free until {{date}}.',
  terms:
    'I agree to the <a href="{{terms_url}}" target="_blank" rel="noreferrer">FoodAmigos Partner Platform Terms</a>, including activation, cancellation and refunds.',
  error: 'We could not complete the purchase. Please try again.',
  loading: 'Checking this restaurant’s plan…',
  load_error: 'We could not check this restaurant’s plan.',
  unavailable: 'This product is not available for this restaurant. Please contact your FoodAmigos account manager.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Online ordering',
          description: 'Direct orders on the restaurant’s own branded website',
        },
        reservations: {
          title: 'Table reservations',
          description: 'Guests book a table directly online',
        },
        marketing: {
          title: 'Marketing Suite',
          description: 'Offer Builder, loyalty points programme and AI replies to Google reviews',
        },
        pricing: {
          title: '0% commission, no setup fee',
          description: 'One licence per location, billed monthly',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'The restaurant’s own branded app',
          description: 'On the App Store and Google Play',
        },
        engagement: {
          title: 'Push notifications and loyalty',
          description: 'Bring guests back with offers and points',
        },
        ordering: {
          title: '0% commission ordering',
          description: 'Direct orders straight from the app',
        },
        apple: {
          title: 'Apple Developer account required',
          description: '$99/year, paid to Apple, in the restaurant’s legal entity',
        },
      },
    },
    ai_website: {
      title: 'Website Builder Subscription',
      subtitle_domain: 'Get {{name}}’s website live on {{domain}}',
      features: {
        domain: {
          title: 'Your website, live on your own domain',
          description: 'The restaurant’s branded website',
        },
        ai: {
          title: 'Built and updated with AI',
          description: 'Create pages, text and images for the restaurant in minutes',
        },
        ordering: {
          title: 'Ordering and reservations built in',
          description: 'Guests order and book a table straight from the website',
        },
        pricing: {
          title: 'No setup fee',
          description: 'One licence per location, billed monthly',
        },
      },
    },
    storefront: {
      title: 'Website Builder Subscription',
      subtitle_domain: 'Get {{name}}’s website live on {{domain}}',
      features: {
        domain: {
          title: 'Your website, live on your own domain',
          description: 'The restaurant’s branded website',
        },
        ai: {
          title: 'Built and updated with AI',
          description: 'Create pages, text and images for the restaurant in minutes',
        },
        ordering: {
          title: 'Ordering and reservations built in',
          description: 'Guests order and book a table straight from the website',
        },
        pricing: {
          title: 'No setup fee',
          description: 'One licence per location, billed monthly',
        },
      },
    },
  },
  payment_method: {
    label: 'Your partner payment method',
    on_file: 'Card on file',
    pending_title: 'Confirming your payment method',
    pending: 'Stripe is still confirming the card you just added. This can take a minute.',
    still_pending: 'Not there yet. Give it a moment and check again.',
    error: 'We could not open the payment form. Please try again.',
  },
  buttons: {
    close: 'Close',
    continue_to_payment: 'Continue to payment',
    start_trial: 'Start {{days}}-day free trial',
    subscribe: 'Start subscription',
    continue: 'Continue',
    change: 'Change',
    retry: 'Try again',
    check_again: 'Check again',
    add_again: 'Add a card again',
  },
};
